(() => {
  if (customElements.get("collapsible-item")) {
    return;
  }

  class CollapsibleItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelector("summary").addEventListener(
        "click",
        this.toggle.bind(this)
      );
    }

    toggle(event) {
      event.preventDefault();
      this.parentElement.querySelector('[is-open]').removeAttribute('is-open')
      this.querySelector("details").toggleAttribute("is-open");
    }
  }

  customElements.define("collapsible-item", CollapsibleItem);
})();
